module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/reward_badge_aurora_ghost-b583deda26e622edf11a8129316e43c8.svg";